import React from 'react';
import { useHistory } from 'react-router-dom';

import createTrack from 'services/actions/tracker_actions';
import conlicitacaoLogo from 'assets/images/logo-conlicitacao-colorido.svg';
import filteredIcon from 'assets/images/upsell-benefit-filtered.svg';
import portalsIcon from 'assets/images/upsell-benefit-portals.svg';
import manageIcon from 'assets/images/upsell-benefit-manage.svg';
import aiIcon from 'assets/images/upsell-benefit-ai.svg';
import comprasGovLogo from 'assets/images/logo-portais/logo-comprasnet.png';
import bllLogo from 'assets/images/logo-portais/logo-bll.png';
import bncLogo from 'assets/images/logo-portais/logo-bnc.png';
import bbmnetLogo from 'assets/images/logo-portais/logo-bbmnet.png';
import { Container } from './styles';

const BIDDINGS_COUNT = '1.284';

const BENEFITS = [
  { icon: filteredIcon, text: 'Receber licitações filtradas pelo seu segmento e região' },
  { icon: portalsIcon, text: 'Monitorar + de 500 portais em um só lugar' },
  { icon: manageIcon, text: 'Gerenciar propostas, prazos e contratos com toda a equipe' },
  { icon: aiIcon, text: 'Ferramentas de IA para gestão do planejamento ao pós participação' },
];

const PORTALS = [
  { name: 'Compras.gov.br', logo: comprasGovLogo },
  { name: 'BLL Compras', logo: bllLogo },
  { name: 'BNC', logo: bncLogo },
  { name: 'BBMNet', logo: bbmnetLogo },
];

interface ConlicitacaoUpsellCardProps {
  source: string;
}

const ConlicitacaoUpsellCard: React.FC<ConlicitacaoUpsellCardProps> = ({ source }) => {
  const history = useHistory();

  const handleVisitDashboard = () => {
    createTrack('ConlicitaSeg Only - Clicou em visitar o dashboard Conlicitação', {
      fonte: source,
    });
    history.push('/painel');
  };

  const handleFreeTrial = () => {
    createTrack('ConlicitaSeg Only - Clicou em cortesia de 15 dias de teste', { fonte: source });
    window.Tawk_API?.maximize?.();
  };

  const handleSeePlans = () => {
    createTrack('ConlicitaSeg Only - Clicou em ver planos e preços', { fonte: source });
    history.push('/planos');
  };

  return (
    <Container>
      <div className="upsell-main">
        <div className="upsell-header">
          <img src={conlicitacaoLogo} alt="ConLicitação" className="upsell-logo" />
          <button
            type="button"
            className="btn btn-link btn-dashboard"
            onClick={handleVisitDashboard}
          >
            Visitar o dashboard Conlicitação
          </button>
        </div>

        <p className="upsell-headline">
          Entregamos <strong>{BIDDINGS_COUNT} licitações</strong> compatíveis ao seu segmento.
        </p>

        <p className="upsell-text">
          Teste o ConLicitação por 15 dias como cortesia e acompanhe essas oportunidades do
          planejamento à pós participação.
        </p>

        <ul className="upsell-benefits">
          {BENEFITS.map((benefit) => (
            <li key={benefit.text}>
              <span className="benefit-icon" aria-hidden="true">
                <img src={benefit.icon} alt="" />
              </span>
              {benefit.text}
            </li>
          ))}
        </ul>

        <div className="upsell-actions">
          <button type="button" className="btn btn-trial" onClick={handleFreeTrial}>
            Quero minha cortesia de 15 dias
          </button>
          <button type="button" className="btn btn-link btn-plans" onClick={handleSeePlans}>
            Ver planos e preços
          </button>
        </div>
      </div>

      <div className="upsell-aside">
        <div className="aside-header">
          <div className="aside-summary">
            <div className="aside-count">{BIDDINGS_COUNT}</div>
            <div className="aside-caption">licitações compatíveis ao seu segmento</div>
          </div>
          <div className="aside-title">Acompanhamos todos os portais, incluindo:</div>
        </div>
        <div className="portal-grid">
          {PORTALS.map((portal) => (
            <div className="portal-logo" key={portal.name}>
              <img src={portal.logo} alt={portal.name} />
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default ConlicitacaoUpsellCard;
